import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPage.css';
import Footer from './Footer';
import { FaCog } from 'react-icons/fa';
import { GameSettingsContext, GameSettingsProvider } from '../contexts/GameSettingsContext';

const PrivacyPage = () => {
  useEffect(() => {
    document.title = "Wunner - Privacy Policy";
  }, []);

  return (
    <div className="policy-container">
      <div>
        <Link to="/">
          <img src="/logo.png" alt="Game Logo" className="policy-logo" />
        </Link>
      </div>

      <Link to="/settings" className="back-to-settings-button">
        <span className="back-settings-text">Settings</span>
        <FaCog className="back-button-icon" />
      </Link>

      <a
        href="https://www.termsfeed.com/live/bc75545b-aa92-4569-8ba1-d88f149edc41"
        target="_blank"
        rel="noopener noreferrer"
        className="privacy-link"
      >
        <h1>Privacy Policy</h1>
      </a>
      
      <Footer />
    </div>
  );
};

export default PrivacyPage;